module.exports = __webpack_public_path__ + "img/td.0076d0af.svg";